import React from "react";
import PropTypes from "prop-types";

class Masonry extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.setState({
			width: this.container.offsetWidth,
		});
		window.addEventListener("resize", this.updateWindowDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateWindowDimensions);
	}

	updateWindowDimensions = () => {
		this.setState({
			width: this.container.offsetWidth,
		});
	};

	render() {
		const { children, minItemWidth, defaultText } = this.props;
		const { width } = this.state;
		const widthToMeasure = width ? width : 0;
		const minWidth = minItemWidth ? minItemWidth : 300;
		const numberOfCols = Math.floor(widthToMeasure / minWidth);

		// const cols = [0, 1, 2];
		const cols = Array.from(new Array(numberOfCols), (val, index) => index);
		const defaultMessage = defaultText ? defaultText : "There are no items to display";

		return (
			<div ref={el => (this.container = el)} className="masonry">
				{children &&
					cols.map((col, index) => {
						return (
							<div key={index} style={{ width: `${100 / cols.length}%` }} className="masonry_column">
								{children.filter((_i, _index) => {
									return (_index - index) % numberOfCols === 0;
								})}
							</div>
						);
					})}
				{!children && <h2 className="default-text">{defaultMessage}</h2>}
			</div>
		);
	}
}

Masonry.propTypes = {
	children: PropTypes.array.isRequired,
	minItemWidth: PropTypes.number.isRequired,
	defaultText: PropTypes.string,
};

export default Masonry;
